import React, { useState } from 'react';
import './Dataupload.css';

/* We accept 'setFileData' tool from App.js to save the file contents */
const DataUpload = ({ setFileData }) => {
  const [countsFile, setCountsFile] = useState(null);
  const [metadataFile, setMetadataFile] = useState(null);

  /* Helper function: Turns a file into a text string so R can read it */
  const readFileAsText = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => resolve(event.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsText(file); 
    });
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    
    /* Check if files are selected */
    if (!countsFile || !metadataFile) {
      alert("Please select both files before uploading.");
      return;
    }

    try {
      /* Read the files into memory (RAM) */
      const countsText = await readFileAsText(countsFile);
      const metaText = await readFileAsText(metadataFile);

      /* Save them into the main App's "Backpack" (State) */
      setFileData({
        counts_text: countsText,
        metadata_text: metaText
      });
      
      alert("Files loaded successfully! You can now proceed to Analysis.");
      
    } catch (error) {
      console.error("Error reading files:", error);
      alert("Failed to read files. Please ensure they are valid text/CSV.");
    }
  };

  return (
    <main className="upload-page">
      <section className="card">
        <h1>Upload Matrices</h1>
        <p className='subtitle'>Select your Data Matrix and Metadata Matrix files (.csv or .txt), then click Upload.</p>
        <form className='upload-form' onSubmit={handleUpload} noValidate>
          <div className='field'> 
              <label className='label' htmlFor="dataMatrix">Data Matrix File<span className='required'>*</span></label>
              {/* When user picks a file, we save it to our local state */}
              <input 
                id="dataMatrix" 
                name="dataMatrix" 
                type="file" 
                accept=".csv, .txt" 
                required 
                onChange={(e) => setCountsFile(e.target.files[0])}
              />
              <small className='hint'>Upload your data matrix file here in .csv or .txt format.</small>
          </div>
          <div className='field'>
              <label className='label' htmlFor="metaDataMatrix">Metadata Matrix File<span className='required'>*</span></label>
              <input 
                id="metaDataMatrix" 
                name="metaDataMatrix" 
                type="file" 
                accept=".csv, .txt" 
                required 
                onChange={(e) => setMetadataFile(e.target.files[0])}
              />
              <small className='hint'>Upload your metadata matrix file here in .csv or .txt format.</small>
          </div>
          <div className='actions'>
              <button type="submit" className='btn_primary'>Upload Matrices</button> 
          </div>
        </form>
      </section>
    </main>
  );
};

export default DataUpload;